import { createContext } from "solid-js";
const FormContext = createContext({});
export default FormContext;
